
import { MarbleMazePuzzle } from "@/models/MapPois/Quest/Puzzle";
import { Quest_CG_MinigameSection } from "@/models/MapPois/Quest/QuestMapPoi";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Validations } from "vuelidate-property-decorators";
import { Game } from "@/models/Game";
import { maxValue, minValue, integer } from "vuelidate/lib/validators";
import ImageSelector from "@/components/Base/ImageSelector.vue";
import ImageBox from "@/components/Base/ImageBox.vue";

@Component({
  components: { ImageBox, ImageSelector },
})
class MarbleMaze extends Vue {
  @Prop({ default: null }) readonly getContentData!: Quest_CG_MinigameSection;
  @Prop({ default: true }) readonly difficultyLevel!: string;
  @Prop({ default: true }) readonly isEditingLocked!: boolean;
  @Prop({ default: null }) readonly gameData!: Game;
  showImageSelectorBool = false;
  rounds = 3;
  imgSrc = "";

  get getImagePath(): string {
    return (
      "/gametype/" +
      this.gameData.gt_uid +
      "/seasons/" +
      this.gameData.seas_uid +
      "/img/puzzle/"
    );
  }

  created(): void {
    this.getDefaultMarbleMazePuzzleData();
  }

  getMarbleMazePuzzleDifficulty(): MarbleMazePuzzle {
    if (this.difficultyLevel === "easy") {
      if (this.getContentData?.puzzle.puzzleData.easy === undefined) {
        this.getContentData!.puzzle.puzzleData.easy = this.setMarbleMazePuzzleData();
      }
      return this.getContentData?.puzzle.puzzleData.easy as MarbleMazePuzzle;
    } else if (this.difficultyLevel === "hard") {
      if (this.getContentData?.puzzle.puzzleData.hard === undefined) {
        this.getContentData!.puzzle.puzzleData.hard = this.setMarbleMazePuzzleData();
        this.getContentData!.puzzle.puzzleData.hard.onFail = this.getContentData.puzzle.puzzleData.hard.onFail;
        this.getContentData!.puzzle.puzzleData.hard.onSuccess = this.getContentData.puzzle.puzzleData.hard.onSuccess;
        this.getContentData!.puzzle.puzzleData.hard.onIncorrect = this.getContentData.puzzle.puzzleData.hard.onIncorrect;
      }
      return this.getContentData?.puzzle.puzzleData.hard as MarbleMazePuzzle;
    } else {
      if (this.getContentData?.puzzle.puzzleData.default === undefined) {
        this.getContentData!.puzzle.puzzleData.default = this.setMarbleMazePuzzleData();
      }
      return this.getContentData!.puzzle.puzzleData.default as MarbleMazePuzzle;
    }
  }

  getDefaultMarbleMazePuzzleData(): void {
    var data = this.getMarbleMazePuzzleDifficulty();
    this.imgSrc = data.map;
    this.rounds = data.numRounds;
  }
  setDefaultMarbleMazePuzzleData(): void {
    var data = this.getMarbleMazePuzzleDifficulty();
    data.numRounds = this.rounds;
    data.map = this.imgSrc;
    this.$emit("updateData", this.getContentData.puzzle.puzzleData);
  }
  returnImagePath(path: string): void {
    this.showImageSelectorBool = false;
    this.imgSrc = this.getImagePath + "" + path;
    this.setDefaultMarbleMazePuzzleData();
  }
  handleCloseButtonPress(): void {
    this.showImageSelectorBool = false;
  }
  setMarbleMazePuzzleData(): MarbleMazePuzzle {
    return {
      numRounds: 3,
      map: "",
      onFail: {
        txt: { en: "Failed!" },
        actions: {
          timerAction: { value: 5, parentID: "", status: "" },
        },
      },
      onSuccess: {
        txt: { en: "Success!" },
      },
      onIncorrect: {
        txt: { en: "Oops!" },
        actions: {
          timerAction: { value: 1, parentID: "", status: "" },
        },
      },
    };
  }
  showImageSelector(): void {
    if (!this.isEditingLocked) {
      this.showImageSelectorBool = true;
    }
  }
  clearImage(): void {
    if (!this.isEditingLocked) {
      this.imgSrc = "";
      //var data = this.getPointTracePuzzleDifficulty();
      //data.imgBackdrop = this.imgBackDrop;
      this.$emit("updateData", this.getContentData.puzzle.puzzleData);
    }
  }

  @Watch("getContentData")
  getContentDataWatch(): void {
    this.getDefaultMarbleMazePuzzleData();
  }

  @Watch("difficultyLevel")
  getdifficultyLevelWatch(): void {
    this.getDefaultMarbleMazePuzzleData();
  }

  @Validations()
  validations = {
    rounds: {
      minValue: minValue(1),
      maxValue: maxValue(10),
      integer,
    },
  };
}
export default MarbleMaze;
